import {
  createContext,
  useContext,
  useMemo,
  useState,
  useEffect,
  ReactNode,
} from 'react';
import { useAuth } from './authContext';
import { isUndefined } from 'lodash';
import { GetSweepContextType } from './getSweepContext.type';
import { Sweep } from '../../utils/helper.type';

const SweepContext = createContext<GetSweepContextType | undefined>(undefined);

export const SweepProvider = ({ children }: { children: ReactNode }) => {
  const [sweepSummary, setSweepSummary] = useState<Sweep[]>([]);

  const { accessToken } = useAuth();

  const contextValue = useMemo(
    () => ({ sweepSummary, setSweepSummary }),
    [sweepSummary],
  );

  useEffect(() => {
    if (isUndefined(accessToken)) {
      setSweepSummary([]);
    }
  }, [accessToken]);

  return (
    <SweepContext.Provider value={contextValue}>
      {children}
    </SweepContext.Provider>
  );
};

export const useSweepSummary = (): GetSweepContextType => {
  const context = useContext(SweepContext);
  if (!context)
    throw new Error('useSweepSummary must be used inside SweepProvider');
  return context;
};
